import type { MessageKey } from "@/lib/i18n";

export type SitePromo = {
  id: string;
  partnerId: string;
  href: string;
  /** Inclusive start (UTC ISO). */
  startsAt: string;
  /** Exclusive end (UTC ISO). */
  endsAt: string;
  titleKey: MessageKey;
  bodyKey: MessageKey;
  periodKey: MessageKey;
  ctaKey: MessageKey;
  ariaKey: MessageKey;
};

/** Active and recent site-wide promotions (admin stats + banner). */
export const SITE_PROMOS: SitePromo[] = [
  {
    id: "yourwobb-nov2026-7off",
    partnerId: "yourwobb",
    href: "https://yourwobb.com/apps/affiliate/share?uid=3FA55BC1A8CD50497F68EC134605EA2A",
    startsAt: "2026-11-01T00:00:00.000Z",
    endsAt: "2026-11-12T00:00:00.000Z",
    titleKey: "promo.yourwobbNov2026.title",
    bodyKey: "promo.yourwobbNov2026.body",
    periodKey: "promo.yourwobbNov2026.period",
    ctaKey: "promo.yourwobbNov2026.cta",
    ariaKey: "promo.yourwobbNov2026.aria",
  },
];

export const SITE_PROMO_IDS = new Set(SITE_PROMOS.map((promo) => promo.id));

export function getActivePromos(now = Date.now()): SitePromo[] {
  return SITE_PROMOS.filter((promo) => {
    const start = Date.parse(promo.startsAt);
    const end = Date.parse(promo.endsAt);
    if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
    return now >= start && now < end;
  });
}

export function getPromoById(id: string): SitePromo | undefined {
  return SITE_PROMOS.find((promo) => promo.id === id);
}
